import React from 'react';
import ReactDOM from 'react-dom/client';
import { Routes, Route, BrowserRouter } from "react-router-dom"
import './index.css';
import reportWebVitals from './config/reportWebVitals';
import Login from './views/login/Login';
import ResetSenha from './views/login/ResetSenha';
import NovaSenha from './views/login/NovaSenha';
import Structure from './views/structure/Structure';
import NotificacaoModalGlobal from './components/notificacao/NotificacaoModalGlobal';

//Teste central pipelines
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
       <NotificacaoModalGlobal />
       <Routes>
         <Route>
           <Route path="/" element={<Login />} />
           <Route path="/esqueci-minha-senha" element={<ResetSenha />} />
           <Route path="/redefinir-senha/:token" element={<NovaSenha />} />
           <Route path="/mvp" element={<Structure />} />
         </Route>
       </Routes>
     </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
